import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { ZoneChip, LageBadge } from "./ui";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function ComparablesCarousel({ listingId }) {
  const { t } = useI18n();
  const [comps, setComps] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/listings/${listingId}/comparables`)
      .then(({ data }) => setComps(data.comparables))
      .catch(() => setComps([]));
  }, [listingId]);

  if (!comps) return null;
  if (comps.length === 0) {
    return (
      <div className="border border-border bg-surface p-4 text-xs font-mono text-text-muted">
        {t("comparables.none")}
      </div>
    );
  }
  return (
    <div className="overflow-x-auto -mx-1">
      <div className="flex gap-px bg-border border border-border min-w-min">
        {comps.map((c) => (
          <button
            key={c.id}
            onClick={() => nav(`/listings/${c.id}`)}
            data-testid={`comparable-${c.id}`}
            className="bg-bg hover:bg-surfaceHover text-left p-4 w-[240px] flex-shrink-0 transition-colors"
          >
            <div className="flex items-center gap-2">
              <ZoneChip zone={c.zone} />
              <LageBadge grade={c.lage_grade} />
            </div>
            <div className="mt-3 text-[11px] text-text-muted font-mono">{c.market_name}</div>
            <div className="mt-1 text-sm leading-tight">{c.title}</div>
            <div className="mt-3 grid grid-cols-3 gap-2 border-t border-border pt-3">
              <Cell label={t("dashboard.colFaktor")} v={c.faktor.toFixed(1)} accent={c.zone.includes("GREEN") ? "g" : c.zone === "YELLOW" ? "y" : "r"} />
              <Cell label={t("listings.price")} v={`€${(c.price/1000).toFixed(0)}k`} />
              <Cell label="m²" v={c.size_m2} />
            </div>
            <div className="mt-3 flex items-center justify-between text-[10px] font-mono">
              <span className={c.monthly_cashflow >= 0 ? "text-signal-green" : "text-signal-red"}>
                {c.monthly_cashflow >= 0 ? "+" : ""}€{c.monthly_cashflow}/mo
              </span>
              <span className="text-text-muted inline-flex items-center gap-1">
                {t("comparables.open")} <ArrowRight size={10} />
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

function Cell({ label, v, accent = "w" }) {
  const cls = { w: "text-white", g: "text-signal-green", y: "text-signal-yellow", r: "text-signal-red" }[accent];
  return (
    <div>
      <div className="overline">{label}</div>
      <div className={`num text-sm mt-0.5 ${cls}`}>{v}</div>
    </div>
  );
}
